import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "form"]
  static values = { pollUrl: String, rePair: { type: Boolean, default: false } }

  connect() {
    this.pollInterval = null
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    if (!this.pollUrlValue) return

    this.pollInterval = setInterval(async () => {
      try {
        const response = await fetch(this.pollUrlValue)
        const data = await response.json()

        if (data.paired) {
          this.stopPolling()
          this.onPaired(data)
        }
      } catch (error) {
        console.error("Pairing poll error:", error)
      }
    }, 2000)
  }

  stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    }
  }

  onPaired(data) {
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = `
        <div class="flex items-center gap-2 text-green-600 dark:text-green-400">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
          <span class="text-sm font-medium">${this.rePairValue ? "Signer re-paired!" : "Account paired! Creating..."}</span>
        </div>
      `
    }

    // For re-pair, the server already updated the account — just redirect
    if (this.rePairValue && data.redirect_url) {
      window.location.href = data.redirect_url
      return
    }

    // POST to /accounts — server retrieves signer data from session
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    fetch("/accounts", {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/html"
      },
      redirect: "follow"
    }).then(response => {
      if (response.redirected) {
        window.location.href = response.url
      } else {
        window.location.href = "/accounts"
      }
    })
  }
}
